import { Text } from "./typography";

interface LoaderProps {
  text?: string;
  inline?: boolean;
  size?: "sm" | "md" | "lg";
}

export function Loader({
  text = "Loading...",
  inline = false,
  size = "md",
}: LoaderProps) {
  const sizeClasses = {
    sm: "h-8 w-8 border-2",
    md: "h-8 w-8 border-4",
    lg: "h-12 w-12 border-4",
  };

  const spinner = (
    <div
      className={`inline-block animate-spin rounded-full border-solid border-primary border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] ${sizeClasses[size]}`}
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        {text}
      </span>
    </div>
  );

  if (inline) {
    return spinner;
  }

  return (
    <div className="fixed inset-0 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
      <div className="text-center">
        {spinner}
        <Text variant="body" tone="body" className="mt-4">
          {text}
        </Text>
      </div>
    </div>
  );
}
